import React from "react";
import "./services.css";
import structures from "../../Assets/Images/structures.jpg";
import fences from "../../Assets/Images/fences.jpg";


const services = () => {
  return (
    <div>
      <section class="services">
        <div class="container ">
          <div className="serviceText">
            <h2 className="heading-style">Our Service Areas</h2>
          <p>
            Serving Mckinney, Prosper, Frisco, Little Elm, Aubrey, Priceton, Anna, Melissa Plano, Ricchardson
          </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default services;
